import { Button } from "@/components/ui/button";
import { Route, Loader2, ArrowUp, ArrowDown } from "lucide-react";

const fmtDur = (s) => { const m = Math.round((s || 0) / 60); return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}min` : `${m} min`; };

// Bloco 5/7 (Iter 99): barra "Sequência da rota" no app do entregador — otimizar (OSRM) + resumo.
export function MobileRotaBar({ ativos, onOtimizar, busy, resumo }) {
  if (ativos === 0) return null;
  return (
    <div className="rounded-2xl border border-orange-200 bg-orange-50 p-3 flex items-center gap-3" data-testid="mobile-rota-bar">
      <Route className="w-6 h-6 text-orange-700 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-extrabold text-orange-900">Sequência da rota · {ativos} entrega(s)</div>
        <div className="text-xs text-orange-800" data-testid="mobile-rota-resumo">
          {resumo ? `~${fmtDur(resumo.duration_s)} · ${((resumo.distance_m || 0) / 1000).toFixed(1)} km` : "Use ↑↓ nos cards ou otimize automaticamente"}
        </div>
      </div>
      <Button size="sm" onClick={onOtimizar} disabled={busy} className="h-9 bg-orange-600 hover:bg-orange-700 font-bold" data-testid="mobile-btn-otimizar">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Otimizar"}
      </Button>
    </div>
  );
}

// Controles de ordem manual por card (↑/↓) — Bloco 7.
export function MobileOrdemControls({ ordem, etaMin, isFirst, isLast, onUp, onDown, busy, id }) {
  return (
    <div className="flex items-center justify-between px-1 -mb-2" data-testid={`mobile-ordem-${id}`}>
      <div className="inline-flex items-center gap-2 text-xs font-bold text-orange-800">
        <span className="w-6 h-6 rounded-full bg-orange-600 text-white flex items-center justify-center text-[11px]" data-testid={`mobile-ordem-num-${id}`}>{ordem ?? "–"}</span>
        {etaMin != null && <span className="text-slate-600 font-medium">~{etaMin} min</span>}
      </div>
      <div className="flex gap-1">
        <Button size="icon" variant="outline" className="h-8 w-8" disabled={isFirst || busy} onClick={onUp} data-testid={`mobile-ordem-up-${id}`} aria-label="Subir"><ArrowUp className="w-4 h-4" /></Button>
        <Button size="icon" variant="outline" className="h-8 w-8" disabled={isLast || busy} onClick={onDown} data-testid={`mobile-ordem-down-${id}`} aria-label="Descer"><ArrowDown className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
